const ColumnSize = [
  { size: '185', smallSize: true },
  { smallSize: true, textCenter: true },
  { smallSize: true, textCenter: true },
  { size: '150', smallSize: true, textRight: true },
];

export default ColumnSize;
